<div class="logo">
  <img *ngIf="payment.paymentSystemImage" class="image" [src]="payment.paymentSystemImage.src" />
</div>
<div class="name">
  <span *ngIf="payment.paymentSystemName">
    {{ payment.paymentSystemName }}
  </span>
  <span>****</span>
  <span>
    {{ payment.lastNumbers }}
  </span>
</div>
<button
  sdButton
  class="button button-remove-payment"
  type="unset"
  size="xs"
  [icon]="iconType.TRASHBIN"
  (click)="removePayment.emit()"
></button>
